'use client'

import { useState, useEffect } from 'react'

const NLE_NAMES = ['Adobe Premiere', 'DaVinci Resolve', 'Final Cut Pro', 'Avid']

export function NLECycler() {
  const [index, setIndex] = useState(0)
  const [isFading, setIsFading] = useState(false)

  useEffect(() => {
    const interval = setInterval(() => {
      setIsFading(true)
      setTimeout(() => {
        setIndex(prev => (prev + 1) % NLE_NAMES.length)
        setIsFading(false)
      }, 300)
    }, 2000)

    return () => clearInterval(interval)
  }, [])

  return (
    <span
      className={`inline-block transition-all duration-300 ${
        isFading ? 'translate-y-2 opacity-0' : 'translate-y-0 opacity-100'
      }`}
    >
      <span className="font-medium text-white/95">{NLE_NAMES[index]}</span>
      <span className="text-white/80">.</span>
    </span>
  )
}
